import { cn } from "@bentolabs/kit/utils";
import { Collapsible as RadixCollapsible } from "radix-ui";

export const Collapsible = ({
  className,
  ...props
}: RadixCollapsible.CollapsibleProps) => {
  return (
    <RadixCollapsible.Root className={cn("group", className)} {...props} />
  );
};

const CollapsibleContent = ({
  className,
  ...props
}: RadixCollapsible.CollapsibleContentProps) => {
  return (
    <RadixCollapsible.Content
      {...props}
      className={cn("CollapsibleContent", className)}
    />
  );
};

Collapsible.Trigger = RadixCollapsible.Trigger;
Collapsible.Content = CollapsibleContent;
